'use strict';

customerZone

/**
 * An element that wraps an input (or select), its label, and any validation-messages together.
 *
 * If the input becomes 'invalid', the entire field will receive the 'invalid' class.
 */
.directive('field', ['$log', '$compile', function($log, $compile){
    return {
        restrict: 'E',
        link: function(scope, element, attrs){
            var inputName = undefined;
            var formController = element.controller('form');
            var validationExpression = attrs.validation;

            var inputController = function(){
                // since the input might not exist yet at link time (because of child directives, for instance)
                // we try to resolve it on every cycle, until we succeed.
                if (!inputName || !formController[inputName])
                    inputName = element.find('input, select').attr('name');

                if (!inputName || !formController[inputName]) return {$validators: {}};
                return formController[inputName];
            };

            if (!formController){
                $log.error('Field requires a form as a parent to function');
                return;
            }

            var updateValidity = function(){
                // Validity is a combination of validity of the field itself, and validity
                // of the model value.
                var modelInvalid = validationExpression ? scope.$eval(validationExpression) : false;
                return element.toggleClass('invalid',
                    !!modelInvalid || (inputController().$invalid && inputController().$touched));
            };

            scope.$watch(
                function(){ return inputController().$invalid && inputController().$touched; },
                updateValidity
            );

            if (validationExpression) {
                var $validationMessage = $('<span class="validationmessage" ' +
                    'ng-show="'+validationExpression+'">{{'+validationExpression+'| translate}}</span>');
                element.append($validationMessage);
                $compile($validationMessage)(scope);
                scope.$watch(validationExpression, updateValidity);
                scope.$watch(
                    function(){ return inputController().$$element; },
                    function(){
                        var $inputElement = inputController().$$element;
                        if (!$inputElement) return;
                        $inputElement.keydown(function(){
                            scope.$apply(validationExpression + '=undefined');
                        });
                    });
            }

            scope.$watch(
                function(){
                    return !!inputController().$validators.required &&
                        !inputController().$validators.required(undefined, undefined);
                },
                function(){
                    return element.toggleClass('required',
                        !!inputController().$validators.required &&
                        !inputController().$validators.required(undefined, undefined));
                }
            );
        }
    };
}]);
